import React from 'react';
import './styles.scss';
import { Popup, Icon } from 'semantic-ui-react';
import { ReactComponent as EpcIsDev } from '~/assets/marketplace-badges/epc-is-dev.svg';
import { ReactComponent as ConductorExclusive } from '~/assets/marketplace-badges/conductor-exclusive.svg';
import { ReactComponent as HotProject } from '~/assets/marketplace-badges/hot-project.svg';
import { ReactComponent as QuickTransaction } from '~/assets/marketplace-badges/quick-transaction.svg';
import { ReactComponent as SellerPaysFee } from '~/assets/marketplace-badges/seller-pays-fee.svg';
import { ReactComponent as TopDeveloperIcon } from '~/assets/marketplace-badges/top-developer.svg';
import { ReactComponent as NotInterestedIcon } from '~/assets/marketplace-badges/not-interested.svg';
import { ReactComponent as InterestedIcon } from '~/assets/marketplace-badges/interested.svg';
import { ReactComponent as BessIcon } from '~/assets/marketplace-badges/bess.svg';

type MarketplaceBadgeProps = {
    badge: any;
};

const MarketplaceBadge: React.FC<MarketplaceBadgeProps> = ({ badge }) => {

    const popupPosition =
        badge.icon === 'notInterested' || badge.icon === 'interested' || badge.icon === 'matched'
            ? 'top right'
            : 'top left';

    return (
        <Popup position={popupPosition} header={badge.name} content={badge.description} trigger={
            <div className={`marketplace-badge ${badge.icon}`}>
                {(() => {
                    switch (badge.icon) {
                        case 'epc-is-dev':
                            return <EpcIsDev />;
                        case 'conductor-exclusive':
                            return <ConductorExclusive />;
                        case 'hot-deal':
                            return <HotProject />;
                        case 'quick-transaction':
                            return <QuickTransaction />;
                        case 'seller-pays-fee':
                            return <SellerPaysFee />;
                        case 'top-developer':
                            return <TopDeveloperIcon />;
                        case 'bess':
                            return <BessIcon />;
                        case 'notInterested':
                            return <NotInterestedIcon />;
                        case 'interested':
                            return <InterestedIcon />;
                        case 'matched':
                            return <Icon name="check" />;
                        default:
                            return null;
                    }
                })()}
            </div>
        } />

    );
};

export default MarketplaceBadge;